import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 790px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`;
